/**
 * EliorGroup.Time.Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type UserRole = 0 | 1 | 2 | 3;

export const UserRole = {
    NUMBER_0: 0 as UserRole,
    NUMBER_1: 1 as UserRole,
    NUMBER_2: 2 as UserRole,
    NUMBER_3: 3 as UserRole
};

